import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section lottery-section" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "section-title medium" }
const _hoisted_4 = { class: "nav-buttons mobile-only" }
const _hoisted_5 = { class: "lottery-container" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = ["alt"]

import { ref, watch, computed } from 'vue'
import LotteryCard from '@/components/LotteryCard.vue'
import LotteryFilters from '@/components/LotteryFilters.vue'
import NavButtons from './base/NavButtons.vue'
import type { UpcomingDraw } from '@/types/lottery'


const __default__ = {
  name: 'LotterySection'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    lotteries: {},
    isFavorited: { type: Function },
    showFilters: { type: Boolean }
  },
  emits: ["favorite", "bet", "removeLottery"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Local copy with _removing property
const localLotteries = ref((props.lotteries || []).map(l => ({ ...l, _removing: false } as UpcomingDraw & { _removing: boolean })));

// Filter states
const searchQuery = ref('');
const selectedCountry = ref('');

// Filtered lotteries based on search and country filters
const filteredLotteries = computed(() => {
  let filtered = [...localLotteries.value];

  // Apply search filter
  if (searchQuery.value) {
    filtered = filtered.filter(draw => 
      (draw.game_name && draw.game_name.toLowerCase().includes(searchQuery.value.toLowerCase())) ||
      (draw.country && draw.country.toLowerCase().includes(searchQuery.value.toLowerCase()))
    );
  }

  // Apply country filter
  if (selectedCountry.value) {
    filtered = filtered.filter(draw => draw.country === selectedCountry.value);
  }

  return filtered;
});

// Filter handlers
const handleSearch = (query: string) => {
  searchQuery.value = query;
};

const handleCountryFilter = (country: string) => {
  selectedCountry.value = country;
};

watch(() => props.lotteries, (newVal) => {
  localLotteries.value = (newVal || []).map(l => ({ ...l, _removing: false }));
});

const handleRemove = (lotteryToRemove: UpcomingDraw) => {
  const idx = localLotteries.value.findIndex(l => l.id === lotteryToRemove.id);
  if (idx !== -1) {
    localLotteries.value[idx]._removing = true;
  }
};

const finalizeRemove = (lotteryToRemove: UpcomingDraw) => {
  const idx = localLotteries.value.findIndex(l => l.id === lotteryToRemove.id);
  if (idx !== -1) {
    emit('removeLottery', lotteryToRemove);
    localLotteries.value.splice(idx, 1);
  }
};

const gridRef = ref<HTMLElement | null>(null)

const scrollLeft = () => {
  if (gridRef.value) {
    const cardWidth = gridRef.value.offsetWidth / 5;
    gridRef.value.scrollLeft -= cardWidth * 5;
  }
}

const scrollRight = () => {
  if (gridRef.value) {
    const cardWidth = gridRef.value.offsetWidth / 5;
    gridRef.value.scrollLeft += cardWidth * 5;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(NavButtons, {
          onOnPrevious: scrollLeft,
          onOnNext: scrollRight
        })
      ])
    ]),
    (_ctx.showFilters)
      ? (_openBlock(), _createBlock(LotteryFilters, {
          key: 0,
          onSearch: handleSearch,
          onFilterCountry: handleCountryFilter
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "scroll-btn scroll-left",
        onClick: scrollLeft
      }, [
        _createElementVNode("img", {
          src: "/img/icons/scroll-left.svg",
          alt: _ctx.$t('forms.scrollLeft'),
          class: "scroll-icon"
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", {
        class: "lottery-grid",
        ref_key: "gridRef",
        ref: gridRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLotteries.value, (lottery) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${lottery.game_slug}-${lottery.id}`
          }, [
            _createVNode(_Transition, {
              name: "fade",
              onAfterLeave: () => finalizeRemove(lottery)
            }, {
              default: _withCtx(() => [
                (!lottery._removing)
                  ? (_openBlock(), _createBlock(LotteryCard, {
                      key: 0,
                      lottery: lottery,
                      isFavorited: _ctx.isFavorited,
                      onFavorite: () => _ctx.$emit('favorite', lottery),
                      onBet: () => _ctx.$emit('bet', lottery),
                      onRemove: ($event: any) => (handleRemove(lottery))
                    }, null, 8, ["lottery", "isFavorited", "onFavorite", "onBet", "onRemove"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["onAfterLeave"])
          ]))
        }), 128))
      ], 512),
      _createElementVNode("button", {
        class: "scroll-btn scroll-right",
        onClick: scrollRight
      }, [
        _createElementVNode("img", {
          src: "/img/icons/scroll-right.svg",
          alt: _ctx.$t('forms.scrollRight'),
          class: "scroll-icon"
        }, null, 8, _hoisted_7)
      ])
    ])
  ]))
}
}

})